module.exports = __webpack_public_path__ + "static/media/heading_authen@2x.bd6af984.png";